import React from 'react';
import NextPage from "./NextPage";


function NextPageContent({...restProps}) {
    return (
        <NextPage to={"/contact"} >    
            <span className="hiring">Have A Project?
            <span style={{color:"white"}}>Let's Talk</span>
            </span>
            <ul className="mt-30">
              <li>
                <span className="mr-10 mb-10">Devlift Media</span>
              </li>
              <li>
                T:{" "}
                <span className="mr-10 mb-10">
                  <a href="tel:+1 (833) 338-5438" rel="noreferrer" target="_blank">
                    +1 (833) 338-5438{" "}
                  </a>
                </span>
              </li>
              <li>
                E:{" "}
                <span className="mr-10 mb-10">
                  {" "}
                  <a
                    href="mailto:info@devlift.com"
                    target="_blank"
                    rel="noreferrer"
                  >
                    info@devlift.com
                  </a>
                </span>
              </li>
            </ul>
        </NextPage>
    );
}

export default NextPageContent;